import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { action, computed, makeObservable, observable } from 'mobx';
export class FieldFilter {
  constructor(name, params) {
    var _params$remote, _params$visible, _params$disabled, _params$matchOnEmpty;
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "remote", void 0);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "fieldName", void 0);
    _defineProperty(this, "matchOnEmpty", void 0);
    _defineProperty(this, "needsRefresh", void 0);
    _defineProperty(this, "applySnapshotListeners", void 0);
    _defineProperty(this, "createSnapshotListeners", void 0);
    this.fieldName = name;
    this.createSnapshotListeners = observable.set();
    this.applySnapshotListeners = observable.set();
    this.remote = (_params$remote = params.remote) !== null && _params$remote !== void 0 ? _params$remote : false;
    this.visible = (_params$visible = params.visible) !== null && _params$visible !== void 0 ? _params$visible : true;
    this.needsRefresh = this.remote || false;
    this.disabled = (_params$disabled = params.disabled) !== null && _params$disabled !== void 0 ? _params$disabled : false;
    this.matchOnEmpty = (_params$matchOnEmpty = params.matchOnEmpty) !== null && _params$matchOnEmpty !== void 0 ? _params$matchOnEmpty : false;
    if (params.initialState !== undefined) {
      this.state = params.initialState;
    }
    makeObservable(this, {
      test: false,
      init: action,
      store: false,
      setState: action,
      isEmpty: computed,
      state: observable,
      remote: observable,
      visible: observable,
      disabled: observable,
      fieldName: observable,
      applySnapshot: action,
      onApplySnapshot: action,
      offApplySnapshot: action,
      matchOnEmpty: observable,
      needsRefresh: observable,
      createSnapshotListeners: observable,
      applySnapshotListeners: observable
    });
  }
  init(store) {
    this.store = store;
  }
  setState(nValue) {
    this.state = nValue;
    if (this.remote) {
      this.needsRefresh = true;
    }
  }
  onApplySnapshot(listener) {
    this.applySnapshotListeners.add(listener);
  }
  offApplySnapshot(listener) {
    this.applySnapshotListeners.delete(listener);
  }
  onCreateSnapshot(listener) {
    this.createSnapshotListeners.add(listener);
  }
  offCreateSnapshot(listener) {
    this.createSnapshotListeners.delete(listener);
  }
  exposeParams() {
    return {
      remote: this.remote,
      visible: this.visible,
      disabled: this.disabled,
      matchOnEmpty: this.matchOnEmpty
    };
  }
  createSnapshot() {
    var deproxyify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var snapshot = {
      state: this.state,
      remote: this.remote,
      visible: this.visible,
      disabled: this.disabled,
      fieldName: this.fieldName,
      needsRefresh: this.needsRefresh,
      matchOnEmpty: this.matchOnEmpty
    };
    if (deproxyify) return JSON.parse(JSON.stringify(snapshot));else return snapshot;
  }
  applySnapshot(snapshot) {
    this.state = snapshot.state;
    this.remote = snapshot.remote;
    this.visible = snapshot.visible;
    this.disabled = snapshot.disabled;
    this.fieldName = snapshot.fieldName;
    this.needsRefresh = snapshot.needsRefresh;
    this.matchOnEmpty = snapshot.matchOnEmpty;
  }
  reconfigure(params) {
    var keys = Object.keys(params);
    for (var key of keys) {
      this[key] = params[key];
    }
  }
  test(location, store) {
    throw new Error('unimplemented');
  }
  get isEmpty() {
    throw new Error('unimplemented');
  }
}
export default FieldFilter;
//# sourceMappingURL=FieldFilter.js.map